import { render, staticRenderFns } from "./SmooHint.vue?vue&type=template&id=e98aa536&"
import script from "./SmooHint.ts?vue&type=script&lang=ts&"
export * from "./SmooHint.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports